module.exports = __webpack_public_path__ + "img/mg.75895c96.svg";